import { render, staticRenderFns } from "./AddView.vue?vue&type=template&id=522045e4&"
import script from "./AddView.vue?vue&type=script&lang=ts&"
export * from "./AddView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports